module.exports = "<ng-progress></ng-progress>\n<router-outlet></router-outlet>\n"